import React from "react";
import { ChipButtonProps } from "interfaces/chip_button.interface";
import { Colors } from "utils/theme.utils";
import "./chip_button.ui.scss";

const ChipButton = (props: ChipButtonProps): React.ReactElement => {
  const { text, icon, isActive = false, onClick, className, backgroundColor, activeBackgroundColor, textColor } = props;

  return (
    <button
      type="button"
      className={`chip_button${isActive ? " chip_button_active" : ""}${className ? ` ${className}` : ""}`}
      aria-pressed={isActive}
      onClick={onClick}
      style={{
        backgroundColor: isActive ? (activeBackgroundColor ?? Colors.primaryColor) : (backgroundColor ?? Colors.white),
        color: textColor ?? Colors.onPrimary,
      }}
    >
      {icon && <img src={icon} alt="" className="chip_button_icon" />}
      <span className="chip_button_text">{text}</span>
    </button>
  );
};

export default ChipButton;
